<template>
    <div :class="['progress-circle', over50, pvalue]">
        <span>{{ value }}%</span>
        <div class="left-half-clipper">
            <div class="first50-bar"></div>
            <div class="value-bar"></div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    },

    mixins: [],

    props: ['value'],

    computed: {
        over50() {
            return this.value > 50 ? 'over50' : '';
        },

        pvalue() {
            return 'p' + Math.round(this.value);
        },
    },

    methods: {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/partials/ProgressBar.vue